import { FC, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";

import { isEmpty } from "lodash";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { makeSxStyles, useGetParamOrRedirect } from "ui";
import { AdRoutes } from "../../constants/ad-routes";
import { useNavigate } from "react-router-dom";
import { useAdminAuthControllerResetPassword } from "service";

const ForgotPasswordCompletePage: FC = () => {
  const navigate = useNavigate();
  const [password1, setPassword1] = useState<string>("");
  const [password2, setPassword2] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const params = useGetParamOrRedirect<{ token: string }>(
    ["token"],
    AdRoutes.login,
  );
  const { mutate, isLoading } = useAdminAuthControllerResetPassword({
    onSuccess: () => {
      navigate(AdRoutes.login);
    },
  });
  const styles = useStyles();

  const onUpdatePassword = () => {
    mutate({
      body: {
        password: password1,
        token: params!.token,
      },
    });
  };

  const passwordsMatch = password1 === password2 && !isEmpty(password1);
  const sufficientLength = password1.length > 7;

  return (
    <Container maxWidth="xs">
      <Box marginBottom="60px" display="flex" justifyContent="center">
        <img src="/snowsync-logo.png" alt="logo" style={{ width: "150px" }} />
      </Box>
      <Grid container rowSpacing={4} direction="column">
        <Grid item xs>
          <TextField
            value={password1}
            onChange={(e) => setPassword1(e.target.value)}
            placeholder="New Password"
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <IconButton
                  sx={styles.iconButton}
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs>
          <TextField
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            placeholder="Repeat Password"
            type={showPassword ? "text" : "password"}
            fullWidth
          />
          <ul>
            <li>
              <Typography color={!isEmpty(password1) ? "primary" : "neutral"}>
                Password is required.
              </Typography>
            </li>
            <li>
              <Typography color={passwordsMatch ? "primary" : "neutral"}>
                Passwords must match.
              </Typography>
            </li>
            <li>
              <Typography color={sufficientLength ? "primary" : "neutral"}>
                Password must be at least 8 characters long.
              </Typography>
            </li>
          </ul>
        </Grid>
        <Grid item xs>
          <Button
            variant="contained"
            disabled={
              isEmpty(password1) ||
              !passwordsMatch ||
              !sufficientLength ||
              !params ||
              isLoading
            }
            fullWidth
            onClick={onUpdatePassword}
          >
            Change password
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

const useStyles = makeSxStyles(({ palette: { neutral } }) => ({
  iconButton: { color: neutral },
}));

export default ForgotPasswordCompletePage;
